'use client';

import * as React from 'react';
import { FilterButton } from './filter-button';
interface FilterButtonGroupProps {
  filters: string[];
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}
export function FilterButtonGroup({
  filters,
  activeFilter,
  onFilterChange
}: FilterButtonGroupProps) {
  return <div className="flex w-full flex-wrap items-center gap-2 overflow-hidden whitespace-nowrap px-6 py-5 text-center text-sm tracking-normal text-zinc-700 max-md:max-w-full max-md:px-5" data-sentry-component="FilterButtonGroup" data-sentry-source-file="filter-button-group.tsx">
      {filters.map(filter => <FilterButton key={filter} label={filter} isActive={activeFilter === filter} onClick={() => onFilterChange(filter)} />)}
    </div>;
}